import { Component, OnInit, OnDestroy} from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import { IAirport } from './airport-interfaces';
import { AirportService } from './airport.service';
import { IScenario, ScenarioService } from '../scenario-activities/scenario.service';
import { UserSession } from '../shared/user-session';
import { UserInfoService } from '../shared/user-info.service';
import { CommonDataService, KeyValuePair } from '../common-data/commondata.service';
import * as _ from 'lodash';


@Component({
    //templateUrl: 'app/airports/airport.component.html',
    template: require('./airport-edit.component.html'),
    styles: [require('./airport.css')],
    //styleUrls: ['app/products/product-list.component.css'],
    providers: [KeyValuePair],
    directives: [ROUTER_DIRECTIVES]
})

export class AirportEditComponent implements OnInit, OnDestroy{
    pageTitle: string = 'Facility Edit ';
    errorMessage: string;
    airport: IAirport;
    private sub: any;    
    currentScenario: IScenario;
    allScenarios: IScenario[];
    displayNotes: boolean = false;
    scenarioNote: string;
    regStartYear: string;
    regEndYear: string;

    regions: KeyValuePair[];  
    states: KeyValuePair[];
    facClasses: KeyValuePair[];
    facLevels: KeyValuePair[];
    sizes: KeyValuePair[];
    flags: KeyValuePair[];

    constructor(private route: ActivatedRoute,
                private router: Router,
                private _airportService: AirportService,
                private _scenarioService: ScenarioService, 
                private _commonDataService: CommonDataService,
                private _userInfoService: UserInfoService,
                private User: UserSession) {
    }

    ngOnInit(): void{
        //TODO: need to see what the original page defaults to 
        this.sub = this.route.params.subscribe(
            params => {
                let id = params['locId'];
                
                //will need to only do this if we get a value
                this.getAirport(id);
        });
        this._scenarioService.getScenarios(this.User.getSession()['id'])//this.User.getSession().userId
            .subscribe(
                scenarios => this.allScenarios = scenarios,
                error => this.errorMessage = <any>error,
                () => {
                    this.setScenarioHeader(this.User.getSession().scenarioId);
                }
            );

        this.getKeyValues('region');
        this.getKeyValues('state');
        this.getKeyValues('emdfcode');
        this.getKeyValues('faclevel');
        this.getKeyValues('hubsize');
        this.getKeyValues('opsflags');

        this._userInfoService.getRegionalYear(this.User.getSession()['id'])//this.User.getSession().userId
            .subscribe(
                success => {
                    this.regStartYear = success.startYear;
                    this.regEndYear = success.endYear;
                }
            );



    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }


    getAirport(locId: string) {
        this._airportService.getAirport(locId, this.User.getSession().scenarioId)
            .subscribe(
                airport => this.airport = airport,
                error =>  this.errorMessage = <any>error);
    }

    private setScenarioHeader(scenarioId: number):void {
        let foundScenarios:IScenario[] = this.allScenarios.filter(function(scenario){
            return scenario.id === scenarioId;
        });
        if(foundScenarios.length > 0){
            this.currentScenario = foundScenarios[0];
        }
    }

    private getKeyValues(id: string)
    {
        this._commonDataService.getData(id)
            .subscribe(
                (list: KeyValuePair[]) => {
                    if(id == "region"){
                        this.regions = list;
                    }
                    else if(id == "state"){
                        this.states = list;
                    }
                    else if(id == "emdfcode"){
                        this.facClasses = list;
                    }
                    else if(id == "faclevel"){
                        this.facLevels = list;
                    }
                    else if(id == "hubsize"){
                        this.sizes = list;
                    }
                    else if(id == "opsflags"){
                        this.flags = list;
                    }
                },
                error => this.errorMessage = <any>error
            );
    }

    updateAirport(){
        this.errorMessage = null;

        if(+this.airport.regionalInputEndYear < +this.airport.regionalInputStartYear){
            this.errorMessage = "Regional input start year cannot be greater than regional input end year.";
            return;
        }

        
        this._airportService.updateAirport(this.airport)
            .subscribe(
                response => {
                    if(response.responseStatus == "success"){
                        this.router.navigate(['/airports', { locId: this.airport.locId}]);
                    }
                    else if(response.responseStatus == "error"){
                        this.errorMessage = "An error occured while trying to update the facility.";
                        console.error(response.responseMessage);
                    }
                },
                error => {
                    this.errorMessage = "An error occured while trying to update the facility.";
                    console.error(error);
                }
            );


    }

    cancelEdit(){
        this.router.navigate(['/airports', { locId: this.airport.locId}]);
    }

    regionalInputChange(event: any){

        //TODO: need to set these to other default values
        if(event.target.checked){
            this.airport.regionalInputStartYear = this.regStartYear;
            this.airport.regionalInputEndYear = this.regEndYear;
        }
    }

}



/** WEBPACK FOOTER **
 ** ./app/airports/airport-edit.component.ts
 **/